import './combo.css';

/**
 * Combo (select) do design system (29/10): o mesmo campo dos inputs (canto reto, borda
 * neutra, halo lilás ao clicar), com seta fina que fica roxa no foco (`combo-seta`, em
 * combo.css). Use em todo <select> nativo: `className={COMBO_CLASS}`; o FormSelect já usa.
 */
export const COMBO_CLASS = [
    'combo-seta appearance-none w-full h-10 rounded-md border border-slate-300/60 bg-white py-2 pl-3 pr-9 text-sm text-slate-900 shadow-sm',
    'transition duration-150 ease-in-out hover:border-slate-400/70',
    'focus:outline-none focus:border-primary focus:border-opacity-40 focus:ring-4 focus:ring-primary focus:ring-opacity-20',
    'disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-500',
    'dark:border-white/15 dark:bg-darkmode-700 dark:text-slate-100 dark:hover:border-white/25 dark:focus:ring-roxo-400/25',
].join(' ');
